import script from "./MockProductListTile.vue?vue&type=script&setup=true&lang=js"
export * from "./MockProductListTile.vue?vue&type=script&setup=true&lang=js"

import "./MockProductListTile.vue?vue&type=style&index=0&id=59c7a3cc&lang=scss"

const __exports__ = script;

export default __exports__